import React, { useEffect, useState } from "react";
import axios from "axios";
import useStore from "../../../store";
import useTranslation from "../../../hooks/useTranslation";
import { enqueueSnackbar } from "notistack";
import {
  navigateSameTab,
  isApiSuccess,
} from "../../../components/Header/paymentHelpers";
import "./style.scss";
import OrderPaymentModal from "./OrderPaymentModal";

const OrderInvoice = ({ orderData, onClose }) => {
  const { tr } = useTranslation();
  const { company } = useStore((s) => s);

  const [invoiceUrl, setInvoiceUrl] = useState("");
  const [showPay, setShowPay] = useState(false);
  const [payLoading, setPayLoading] = useState(false);

  useEffect(() => {
    if (!orderData?.id) return;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}online-menu/orders/${orderData.id}/print`
      )
      .then((resp) => {
        setInvoiceUrl(
          resp?.config?.url ||
            `${process.env.REACT_APP_API_URL}online-menu/orders/${orderData.id}/print`
        );
      })
      .catch(console.log);
  }, [orderData?.id]);

  const paymentBtn = async (amountParam) => {
    try {
      if (!company?.id) {
        enqueueSnackbar(tr("Организация не найдена"), { variant: "warning" });
        return;
      }
      const orderIds = [orderData?.id].filter(Boolean);
      if (!orderIds.length) {
        enqueueSnackbar(tr("Нет активных заказов"), { variant: "warning" });
        return;
      }
      const resp = await axios.post(
        `${process.env.REACT_APP_API_URL}app/orders/remote/pay`,
        {
          payment_type: "hamkorbank",
          order_ids: orderIds,
          amount: amountParam ?? 0,
        }
      );
      const ok = isApiSuccess(resp);
      const link = resp?.data?.data?.result?.url;
      if (ok && link) {
        navigateSameTab(link);
        enqueueSnackbar(tr("Ссылка на оплату отправлена"), {
          variant: "success",
        });
      } else {
        enqueueSnackbar(tr("Не удалось получить ссылку на оплату"), {
          variant: "error",
        });
      }
    } catch (err) {
      enqueueSnackbar(
        err?.response?.data?.message || tr("Не удалось провести оплату"),
        {
          variant: "error",
        }
      );
    }
  };

  const handlePaySubmit = async (amountNum) => {
    setPayLoading(true);
    try {
      await paymentBtn(amountNum);
      setShowPay(false);
    } finally {
      setPayLoading(false);
    }
  };

  return (
    <div className="invoice">
      {/* Sticky header: chapda X, o‘ngda Оплата */}
      <div className="invoice__header">
        <button
          type="button"
          className="invoice__close"
          aria-label={tr("Закрыть")}
          title={tr("Закрыть")}
          onClick={onClose}
        >
          ✕
        </button>
        <div className="invoice__spacer" />
        <button
          className="pay-btn"
          onClick={() => setShowPay(true)}
          type="button"
          title={tr("Оплата")}
        >
          <span className="pay-btn__icon" aria-hidden>
            💳
          </span>
          <span className="pay-btn__text">{tr("Оплата")}</span>
        </button>
      </div>

      {/* Iframe butun qolgan joyni egallaydi */}
      <div className="invoice__body">
        <iframe src={invoiceUrl} title="invoice" className="invoice__frame" />
      </div>

      <OrderPaymentModal
        open={showPay}
        loading={payLoading}
        onClose={() => setShowPay(false)}
        onSubmit={handlePaySubmit}
        tr={tr}
        variant="right"
        title={tr("Оплата")}
        orderData={orderData}
      />
    </div>
  );
};

export default OrderInvoice;
